const action = {
}

export default action



// WEBPACK FOOTER //
// ./src/vuex/modules/user/action.js